export const isSafari =
  typeof window !== 'undefined' && /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent)

export const SAFARI_MAX_CANVAS_SIZE = 4096
